const ITEMS = [
  "Pulverización de precisión",
  "DJI Agras T100",
  "Siembra al voleo",
  "Mapas multiespectrales",
  "Soporte en campo 24/7",
  "Llave en mano",
  "Santa Cruz · Beni · Cochabamba",
  "CERTERO Academy",
  "Mavic 3M",
  "Garantía de fábrica 1 año",
];

export default function Marquee() {
  return (
    <div
      data-testid="marquee-ticker"
      className="group relative overflow-hidden border-y border-hud bg-ink py-4"
      aria-label="Especialidades de CERTERO"
    >
      <div className="flex w-max animate-marquee items-center gap-0 group-hover:[animation-play-state:paused]">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
            {ITEMS.map((item, i) => (
              <span
                key={`${copy}-${i}`}
                className="flex items-center gap-6 pr-6 font-mono text-[11px] uppercase tracking-[0.25em] text-mist/60 sm:text-xs"
              >
                {item}
                <span className="text-certero" aria-hidden="true">+</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
